import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
import { Translate } from 'core/translate';
import {
  ButtonIcon,
  ButtonText,
  PrimaryButton,
  ThemedButton
} from 'core/controls';
import MathBox from '../../components/mathBox/MathBox';
import PriceSummaryExpandedDisclaimers from './PriceSummaryExpandedDisclaimers';
import { LayoutContext } from '../LayoutManager';

const PriceSummaryExpandedContent = props => {
  const {
    pricing,
    eligibleForInvoicePrice,
    eventName,
    country,
    isFamilyFirstUS
  } = props;
  return (
    <div className="price-summary-expanded__content">
      <span className="price-summary-expanded__math-box">
        <MathBox
          isFamilyFirstUS={isFamilyFirstUS}
          pricing={pricing}
          country={country}
          eventName={eventName}
          inlineIncentives={true}
          isSummary={false}
          eligibleForInvoicePrice={eligibleForInvoicePrice}
        />
      </span>
      <PriceSummaryExpandedDisclaimers pricing={pricing} />
    </div>
  );
};

class PriceSummaryExpanded extends Component {
  constructor(props) {
    super(props);
    this.$body = document.body;
    this.state = {
      screenSize: MediaQuery.atLeast('large')
    };
    this.onResize = this.onResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    if (!this.state.screenSize) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    document.body.style.overflow = '';
  }

  onResize() {
    const oldScreenSize = this.state.screenSize;
    const screenSize = MediaQuery.atLeast('large');

    if (oldScreenSize !== screenSize) {
      this.setState({
        screenSize
      });
    }

    if (!screenSize) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  render() {
    const {
      displayThumbnail,
      driveType,
      trim,
      config,
      year,
      pricing,
      eligibleForInvoicePrice,
      eventName,
      country,
      isFamilyFirstUS,
      expandedRef,
      topHeight,
      onClose
    } = this.props;
    return (
      <Fragment>
        <div className="price-summary-expanded__overlay" />
        <div
          className={
            'price-summary-expanded ' +
            (displayThumbnail
              ? 'price-summary-expanded--thumbnail-displayed'
              : '')
          }
          style={{ top: topHeight }}
          ref={expandedRef}>
          <div className="price-summary-expanded__inner">
            <div className="price-summary-expanded__container">
              <div className="price-summary-expanded__container-scrollable">
                <div className="price-summary-expanded__subheader hide-for-large">
                  <div className="price-summary-expanded__trim-attributes">
                    <Translate
                      value="component.trim.attributes.label"
                      driveType={driveType}
                      trim={trim}
                      config={config}
                      year={year}
                    />
                  </div>
                </div>

                <PriceSummaryExpandedContent
                  pricing={pricing}
                  eligibleForInvoicePrice={eligibleForInvoicePrice}
                  eventName={eventName}
                  country={country}
                  isFamilyFirstUS={isFamilyFirstUS}
                />
              </div>
            </div>
            <div className="price-summary-expanded__button-container">
              <div className="price-summary-expanded__button-container-inner">
                <ThemedButton
                  as={Link}
                  analytics="button"
                  to="/summary"
                  data-dtm="nav"
                  className="price-summary-expanded__button price-summary-expanded__button--secondary"
                  theme={{
                    fallback: 'button--secondary',
                    buick: 'button--link',
                    cadillac: 'button--link button--inline-flex',
                    gmc: 'button--link'
                  }}>
                  <ButtonText>
                    <Translate value="byo.page.general.go.to.summary" />
                  </ButtonText>
                  <ButtonIcon name="chevron-right" />
                </ThemedButton>
                <PrimaryButton
                  analytics="button"
                  onClick={onClose}
                  data-dtm="nav"
                  className="price-summary-expanded__button price-summary-expanded__button--primary">
                  <ButtonText>
                    <Translate value="byo.page.general.close" />
                  </ButtonText>
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const PriceSummaryExpandedWithLayout = props => (
  <LayoutContext.Consumer>
    {({ navRef, priceSummaryExpandedRef, height }) => (
      <PriceSummaryExpanded
        {...props}
        topHeight={height}
        expandedRef={priceSummaryExpandedRef}
        navRef={navRef}
      />
    )}
  </LayoutContext.Consumer>
);

export default PriceSummaryExpandedWithLayout;
